import { NgClass } from "@angular/common";
import { ChangeDetectionStrategy, Component, HostListener, inject, OnDestroy, signal } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import { Subscription } from "rxjs";

@Component({
  selector: 'lpcr-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [
    NgClass
  ]
})
export class UserMenuComponent implements OnDestroy {
  private readonly router = inject(Router);
  private readonly routerEventSubscription: Subscription;

  protected readonly isMenuOpen = signal<boolean>(false);

  constructor() {
    this.routerEventSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.isMenuOpen.set(false);
      }
    });
  }

  public ngOnDestroy(): void {
    this.routerEventSubscription.unsubscribe();
  }

  @HostListener('click', ['$event'])
  public click($event: PointerEvent): void {
    $event.stopPropagation();
  }

  @HostListener('document:click')
  public onDocumentClick(): void {
    this.isMenuOpen.set(false);
  }

  public toggleMenu($event: Event): void {
    $event.stopPropagation();
    this.isMenuOpen.set(!this.isMenuOpen());
  }
}
